import { useState } from 'react';

export default function useQueryString(urlParams, name) {
  const currentValue = urlParams.get(name);

  const [state, setState] = useState(currentValue);

  function setQueryString(value) {
    if (!value) {
      urlParams.delete(name);
    } else {
      urlParams.set(name, value);
    }
    setState(value);

    window.history.replaceState(
      {},
      '',
      `${window.location.href.split('?')[0]}?` + urlParams
    );
  }

  return [state, setQueryString];
}
